import React from 'react';
import DayLocationCard from './DayLocationCard';
import {
	DAY_LABELS,
	candidateTeachersForBlock,
	dayKeyName,
	flagBlock,
	formatDayKeyDate,
	formatWeekLabel,
	groupBlocksByDay,
	rotationMemoryFor,
	startOfWeek,
} from './schedulingModel';

/**
 * The week board — day rows, one card per day-location block.
 *
 * Day ordering comes from the day keys handed in, so the Sunday-first decision
 * lives in schedulingModel.WEEK_STARTS_ON rather than being re-derived here.
 */
function WeekBoard({
	dayKeys,
	groupByWeek = false,
	blocks,
	teachers,
	teachersById,
	teacherNameById,
	timeOffDates,
	rotationHistory,
	todayKey = null,
	condensed,
	expandLessons,
	isAdmin,
	busy,
	pendingBlockKeys,
	onTeacherChange,
	onToggleLock,
	onSaveBlock,
}) {
	const rows = groupBlocksByDay(blocks, dayKeys);

	// A month of day rows is hard to place yourself in, so in range scope each
	// week gets a heading and "the week of Sep 14" becomes findable by scanning
	// rather than by counting rows. Off in week scope, where the board IS one
	// week and a heading would only repeat the nav above it.
	let lastWeekKey = null;

	return (
		<div className='ts-board'>
			{rows.map(({ dayKey, blocks: dayBlocks }) => {
				const weekKey = startOfWeek(dayKey);
				const showWeekHeading = groupByWeek && weekKey !== lastWeekKey;
				if (showWeekHeading) lastWeekKey = weekKey;
				return (
					<React.Fragment key={dayKey}>
						{showWeekHeading && (
							<h3 className='ts-weekhead'>{formatWeekLabel(weekKey)}</h3>
						)}
						<section className='ts-dayrow' aria-label={dayKey}>
					<div className='ts-dayrow__label'>
						<span className='ts-dayrow__name'>{DAY_LABELS[dayKeyName(dayKey)]}</span>
						<span className='ts-dayrow__date'>{formatDayKeyDate(dayKey)}</span>
					</div>

					<div className='ts-dayrow__cards'>
						{dayBlocks.length === 0 ? (
							<p className='ts-dayrow__empty'>No lessons scheduled</p>
						) : (
							dayBlocks.map((block) => (
								<DayLocationCard
									key={block.key}
									block={block}
									flags={flagBlock({ block, teachersById, timeOffDates, rotationHistory, todayKey })}
									rotation={rotationMemoryFor(block, rotationHistory)}
									candidates={candidateTeachersForBlock({
										block,
										teachers,
										timeOffDates,
										rotationHistory,
									})}
									teacherNameById={teacherNameById}
									condensed={condensed}
									expandLessons={expandLessons}
									isAdmin={isAdmin}
									busy={busy}
									hasPendingChange={pendingBlockKeys.has(block.key)}
									onTeacherChange={onTeacherChange}
									onToggleLock={onToggleLock}
									onSave={onSaveBlock}
								/>
							))
						)}
					</div>
						</section>
					</React.Fragment>
				);
			})}
		</div>
	);
}

export default WeekBoard;
